<template lang="pug">
    #loading
        v-dialog(v-model="$store.state.global.isLoading" persistent width="300")
            v-card(color="primary" dark)
                v-card-title
                    v-progress-linear(indeterminate color="white")
</template>
<script>
export default {
  props: {},
  data() {
    return {}
  },
  methods: {},
  created() {}
}
</script>
<style lang="sass" scoped></style>
